import { ChangeDetectionStrategy, Component, Input, Output, EventEmitter, Signal, ChangeDetectorRef } from '@angular/core';
import { IPortal } from './interface/IPortal';
import { RolesMenuService } from 'src/app/apps/nodo/modules/administracion/services/roles-menus.service';
import { LoaderService } from 'src/app/shared/services/loader.service';
import { SStorageService } from 'src/app/shared/services/sessionStorage.service';
import { Router } from '@angular/router';
import { CoreService } from 'src/app/shared/services/core.service';

export interface IPortalSelected {
  id: string;
  isRefresh: boolean;
}

@Component({
  selector: 'app-app-sidebar',
  templateUrl: './app-sidebar.component.html',
  styleUrls: ['./app-sidebar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppSidebarComponent {
  @Input() theme!: Signal<'light' | 'dark'>;
  @Output() portalId = new EventEmitter<IPortalSelected>(); // Usar EventEmitter para Output
  selected: IPortalSelected = { id: '1', isRefresh: false }; // Cambia según la opción seleccionada
  portal: IPortal[];
  /**
   *
   */
  constructor(
    private rolesMenuService: RolesMenuService,
    private cdr: ChangeDetectorRef,
    private loader: LoaderService,
    private router: Router,
    private coreService: CoreService,
    private sstorageService: SStorageService // Inyectar el servicio de almacenamiento de sesión
  ) {
    const url = this.sstorageService.getItem('url');
    // Solo se restaura si apunta dentro del shell. Un valor viejo o inexistente (menú
    // renombrado, ruta de otro portal) no hace match con ninguna ruta y cae en el comodín
    // '**' → redirect a /login: el usuario acababa de autenticarse y salía disparado de
    // vuelta al login, con el loader colgado porque este layout se destruye a medias.
    if (url && String(url).replace(/^\/+/, '').startsWith('app/')) {
      this.router.navigate([url]); // Navegar a la URL almacenada en sesión
    } else if (url) {
      this.sstorageService.removeItem('url');
    }
  }

  ngAfterViewInit() {
    this.getPortales();
  }

  get logo(): string {
    return this.theme() === 'dark' ? 'assets/images/logos/x-dark.png' : 'assets/images/logos/x-light.png';
  }

  setSelected(option: string, isRefresh: boolean) {
    this.selected = { id: option, isRefresh };
    this.portalId.emit({ id: this.selected.id, isRefresh: this.selected.isRefresh }); // Emitir un objeto con el valor seleccionado y isRefresh
    this.sstorageService.setItem('portalId', this.selected.id); // Almacenar el ID del portal seleccionado en sesión
    if (this.selected && this.selected.id) {
      this.coreService.setIdPortal(this.selected.id); // Actualizar la señal en CoreService
    }
  }

  getPortales() {
    // this.loader.show('Cargando portales...'); // Mostrar loader mientras se cargan los portales
    this.rolesMenuService.getPortales().subscribe({
      next: (res) => {
        this.loader.hide(); // Ocultar loader una vez que se obtienen los portales
        if (res !== null && res.data != null) {
          this.portal = res.data
            .map((portal: any) => ({
              id: portal.id,
              descripcion: portal.tituloMenu,
              icono: portal.icono
            })) as IPortal[];
          // Ordenar los portales por id (asumiendo que id es string, si es número, convertir)
          this.portal.sort((a, b) => a.id.localeCompare(b.id));
          this.validatePortalIdSS();
          this.cdr.markForCheck(); // Marcar para verificación de cambios
        }
      },
      error: (error) => {
        this.loader.hide(); // Ocultar loader en caso de error
        console.error('Error al obtener los portales:', error);
      }
    });
  }

  validatePortalIdSS() {
    const portalIdSS = this.sstorageService.getItem('portalId');
    if (portalIdSS) {
      this.setSelected(portalIdSS, true); // Establecer el portal seleccionado desde la sesión
    } else {
      this.setSelected(this.portal[0].id, false); // Establecer el primer portal como seleccionado si no hay ID en sesión
    }
  }
}
